import { reactive } from "vue";
import { useFeacturesRouter } from "../useFeacturesRouter";
import {useUtilities} from "../useUtilities";

/**
 * Crea un istanza di una modale, gestendo l'aggiornamento dell'url
 * I dati reattivi non sono direttamente modificabili.
 * Ma possono essere aggiornati solo chiamando i metodi interni.
 * Poichè oltre all'aggiornamento del valore gestiscono l'aggiornamento
 * dei riferimenti nell'url
 *
 * Per leggere invece il valore si consiglia di usare i relativi metodi get, cosi da non dover aggiungere .value ad ogni proprietà
 *
 * Come parametri oltre all'id e titolo della modale, usa il booleano have_feacture. Se true vuol dire che è una funzionalità richiamabile via URL.
 *
 * @example const VARIABILE_MODALE = useDefineModal('idprova', 'titolo'); VARIABILE_MODALE.getShow()
 * @param {string} modalID - id della modale e parametro pushato nell'url
 * @param {string} modalTitle - titolo della modale da mostrare graficamente
 * @param {boolean} have_feacture - se true pusha modalID nell'url
 * @param {Object|Array} params - parametri aggiuntivi necessari per attivare la funzionalità via Url
 * @param {Function} callback - funzione da eseguire quando si attiva la la funzionalità via Url
 */
export function useDefineModal(modalID, modalTitle, have_feacture = true, params = null, callback = null) {
  const {pushAction, deleteAction, registerFeacture, updateFeacture} = useFeacturesRouter()

  const data = reactive({
    id: modalID,
    title: modalTitle,
    isShow: false,
    params: params
  })

  /**
   * Ritorna il valore dell'id della modale
   */
  const getId = () => data.id;

  /**
   * Ritorna il valore del titolo della modale
   */
  const getTitle = () => data.title;

  /**
   * Ritorna il valore del toggler della modale
   */
  const getShow = () => data.isShow;

  /**
   * Permette di cambiare l'id della modale
   * @param id
   */
  const changeId = (id) => {
    data.id = id;
  };

  /**
   * Aggiunge in url il riferimento della modale e la mostra
   * @param params
   * @return {Promise<void>}
   */
  const open = async(params = null) => {
    if(have_feacture) await pushAction(data.id, data.params);
    if(callback && params) await callback(params);
    data.isShow = true;
  };

  /**
   * Toglie dall'url il riferimento della modale e la nasconde
   */
  const close = async() => {
    if(have_feacture) await deleteAction(data.id);
    data.isShow = false;
  };

  /**
   * Permette di cambiare il titolo della modale
   * @param title
   */
  const changeTitle = (title) => data.title = title;

  const {makeFlat} = useUtilities();

  /**
   * Permette di cambiare l'id della modale
   * @param params
   */
  const changeParams = async(params) => {
    data.params = params;
    await updateFeacture(data.id, makeFlat(data.params))
  };


  // init della funzionalità della modale via URL
  if(have_feacture) registerFeacture(data.id, open, makeFlat(data.params), 'modal')

  return {
    getId,
    getTitle,
    getShow,
    open,
    close,
    changeTitle,
    changeId,
    changeParams
  }
}